"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _gerenciatdUtils = require("@bit/gerenciatd.utils.common");
var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.button"));
var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.text-info"));
var _gerenciatdUnifiedcomponents3 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.info-list"));
var _gerenciatdUnifiedcomponents4 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));
var _gerenciatdUnifiedcomponents5 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.price"));
var _gerenciatdUnifiedcomponents6 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.claim"));
var _gerenciatdUnifiedcomponents7 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.call4-selling"));
var _gerenciatdUnifiedcomponents8 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.inline-components"));
var _gerenciatdUnifiedcomponents9 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.image"));
var _gerenciatdUnifiedcomponents10 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.promo-strip-extended"));
var _PromoBar = _interopRequireDefault(require("../../PromoBar"));
var _bannerUtils = require("../../bannerUtils");
var _constants = require("../../constants");
require("./Layout1.scss");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /* Used Components */
const Layout1 = props => {
  const finalProps = (0, _gerenciatdUtils.setUpPropsByDevice)(props);
  const {
    components,
    idBanner,
    widthUnit,
    width,
    infoBoxColor,
    SvgIconLoader,
    pictureBoxHeight,
    bannerMinHeight,
    mainTaggingInfo,
    type,
    fullClickable
  } = finalProps;
  let fullLink = '';
  let fullTaggingInfo = null;
  let forceExternal = false;
  let target;
  /* Extraemos el link del button-2 */
  if (components && components['Button-2'] && components['Button-2'].link && mainTaggingInfo) {
    fullLink = components['Button-2'].link;
    forceExternal = components['Button-2'].forceExternal ? components['Button-2'].forceExternal : false;
    fullTaggingInfo = mainTaggingInfo;
    target = components['Button-2'].target;
  }
  const widthProcessed = (0, _bannerUtils.handleContentWidth)(widthUnit, width);
  let inlineStyles = {};
  let columnCss = 'col-xs-12 col-sm-6';
  if (typeof widthProcessed === 'object') {
    inlineStyles = widthProcessed;
    columnCss = 'info';
  }
  if (typeof widthProcessed === 'string') {
    columnCss = `${widthProcessed}`;
    inlineStyles = {};
  }

  // INFOLIST TIENE FLEX o grid ?
  let cssInfolist = '';
  if (components && components['InfoList-1'] && components['InfoList-1'].kind) {
    cssInfolist = `infoList_width--${components['InfoList-1'].kind}`;
  }
  // min height css
  const minHeightCss = `minHeight--${bannerMinHeight}`;

  // LETS CHECK IF THIS BANNER HAS PRODUCT
  const cndHasProduct = components['Image-1'] && components['Image-1'].src && components['Image-1'].div2Fit;
  const cndHasProductsecondImage = components['Image-2'] && components['Image-2'].src && components['Image-2'].div2Fit;
  // Tratamiento fondo del banner
  const {
    whereDiv2Fit,
    cssbgColor
  } = (0, _bannerUtils.generateBgAndProperties)(idBanner, components, 'Layout1');
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    id: idBanner,
    className: `banner layout1 banner_bgColor${cssbgColor}`,
    children: [components['PromoStripExtended-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "promostrip",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents10.default, {
          components: components['PromoStripExtended-1']
        })
      })
    }), fullLink && fullTaggingInfo && fullClickable && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents4.default, {
      className: "zIndex-1",
      isBlockElement: true,
      link: fullLink,
      target: target,
      taggingInfo: fullTaggingInfo,
      forceExternal: forceExternal
    }), whereDiv2Fit !== 'container' && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `banner_shade  banner_shade_left banner_shade_left${cssbgColor}`
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `banner_shade banner_shade_right banner_shade_right${cssbgColor}`
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: `container mainContainer banner--bgcontain banner--bgleft ${minHeightCss}`,
      children: [whereDiv2Fit === 'container' && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: `banner_shade  banner_shade_left banner_shade_left${cssbgColor}`
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: `banner_shade banner_shade_right banner_shade_right${cssbgColor}`
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "row direction-rtl marginVertical0",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: `middleCentered direction-ltr ${columnCss}`,
          style: inlineStyles,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "infoContainer",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: `banner-container banner-container_color--${infoBoxColor} container`,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "row mainContent directionFloating",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  className: type === _constants.BANNER_KIND.LAYOUT1_FLOTANTE && components['Image-1'] ? 'col-sm-8 col-xs-8 col-lg-8' : 'col-sm-12 col-xs-12 col-lg-12',
                  children: [components['TextInfo-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({}, components['TextInfo-1']), {}, {
                    className: "textInfo1"
                  })), components['TextInfo-2'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({}, components['TextInfo-2']), {}, {
                    className: "textInfo2"
                  })), !cndHasProduct && !cndHasProductsecondImage && components['TextInfo-3'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({}, components['TextInfo-3']), {}, {
                    className: "textInfo3"
                  })), cndHasProduct && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    className: "subContainer",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      className: "infoGap",
                      children: [components['TextInfo-3'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({}, components['TextInfo-3']), {}, {
                        className: "textInfo3"
                      })), components['InfoList-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, _objectSpread(_objectSpread({}, components['InfoList-1']), {}, {
                        SvgIconLoader: SvgIconLoader,
                        className: cssInfolist
                      })), components['TextInfo-4'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({}, components['TextInfo-4']), {}, {
                        className: "textInfo4"
                      })), components['Claim-1'] && components['Claim-1'].label && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents6.default, _objectSpread(_objectSpread({}, components['Claim-1']), {}, {
                        className: "claim1"
                      }))]
                    }), cndHasProduct && components['Image-1'].div2Fit === 'inside' && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      className: components['Image-2'] ? 'pictureGap--secondImage middle' : 'pictureGap',
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents9.default, _objectSpread(_objectSpread({}, components['Image-1']), {}, {
                        className: `product${components['Image-1'].div2Fit} ${components['Image-2'] ? 'imgSize middle' : ''}`,
                        dynamicResize: true
                      }))
                    }), cndHasProductsecondImage && components['Image-2'].div2Fit === 'inside' && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      className: "pictureGap--secondImage",
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents9.default, _objectSpread(_objectSpread({}, components['Image-2']), {}, {
                        className: `product${components['Image-2'].div2Fit} ${components['Image-2'] ? 'imgSize' : ''}`,
                        dynamicResize: true
                      }))
                    })]
                  }), !cndHasProduct && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
                    children: [components['InfoList-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, _objectSpread(_objectSpread({}, components['InfoList-1']), {}, {
                      SvgIconLoader: SvgIconLoader,
                      className: cssInfolist
                    })), components['TextInfo-4'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({}, components['TextInfo-4']), {}, {
                      className: "textInfo4"
                    })), components['Claim-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents6.default, _objectSpread(_objectSpread({}, components['Claim-1']), {}, {
                      className: "claim1"
                    }))]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    className: "priceContainer",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_gerenciatdUnifiedcomponents8.default, {
                      className: "inlineComponents",
                      justify: "left",
                      children: [components['Price-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents5.default, _objectSpread(_objectSpread({}, components['Price-1']), {}, {
                        className: "price1"
                      })), components['Price-2'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents5.default, _objectSpread(_objectSpread({}, components['Price-2']), {}, {
                        className: "price2"
                      })), components['Claim-2'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents6.default, _objectSpread(_objectSpread({}, components['Claim-2']), {}, {
                        className: "claim2"
                      }))]
                    })
                  }), components['TextInfo-5'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({}, components['TextInfo-5']), {}, {
                    className: "textInfo5"
                  }))]
                }), type === _constants.BANNER_KIND.LAYOUT1_FLOTANTE && components['Image-1'] && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  className: "col-sm-4 col-xs-4 col-lg-4 images",
                  children: [components['Image-1'] && components['Image-1'].div2Fit && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents9.default, _objectSpread(_objectSpread({}, components['Image-1']), {}, {
                    className: `product${components['Image-1'].div2Fit} ${components['Image-2'] ? 'middle' : ''} ${components['Image-1'] ? 'imgSize' : ''} `,
                    dynamicResize: true
                  })), components['Image-2'] && components['Image-2'].div2Fit && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents9.default, _objectSpread(_objectSpread({}, components['Image-2']), {}, {
                    className: `product${components['Image-2'].div2Fit} ${components['Image-2'] ? 'imgSize' : ''}`,
                    dynamicResize: true
                  }))]
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: "row ButtonContainer ButtonContainer1",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "col-sm-12 col-xs-12",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_gerenciatdUnifiedcomponents8.default, {
                    className: "inlineComponents",
                    justify: "left",
                    children: [components['Call4Selling-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents7.default, _objectSpread(_objectSpread({}, components['Call4Selling-1']), {}, {
                      taggingInfo: mainTaggingInfo
                    })), components['Button-2'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({}, components['Button-2']), {}, {
                      taggingInfo: mainTaggingInfo
                    }))]
                  })
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: "row buttonContainer buttonContainer2",
                children: components['Call4Selling-2'] && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "col-sm-12 col-xs-12",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents7.default, _objectSpread(_objectSpread({}, components['Call4Selling-2']), {}, {
                    taggingInfo: mainTaggingInfo
                  }))
                })
              })]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: `pictures pictures--${pictureBoxHeight} ${type === _constants.BANNER_KIND.LAYOUT1_MARCA_MODELO ? 'picturesaligmentCenter' : ''}`,
            children: [components['Image-1'] && components['Image-1'].div2Fit && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents9.default, _objectSpread(_objectSpread({}, components['Image-1']), {}, {
              className: `product${components['Image-1'].div2Fit} ${components['Image-2'] ? 'middle' : ''} ${components['Image-1'] ? 'imgSize' : ''}`,
              dynamicResize: true
            })), components['Image-2'] && components['Image-2'].div2Fit && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents9.default, _objectSpread(_objectSpread({}, components['Image-2']), {}, {
              className: `product${components['Image-2'].div2Fit} ${components['Image-2'] ? 'imgSize' : ''}`,
              dynamicResize: true
            }))]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: type === _constants.BANNER_KIND.LAYOUT1_FLOTANTE ? 'imgsHide' : '',
          children: [cndHasProduct && components['Image-1'].div2Fit === 'outside' && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "col-sm-3 outsidePictureGap ",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents9.default, _objectSpread(_objectSpread({}, components['Image-1']), {}, {
              className: `product${components['Image-1'].div2Fit}`,
              dynamicResize: true
            }))
          }), cndHasProductsecondImage && components['Image-2'].div2Fit === 'outside' && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "col-sm-3 outsidePictureGap",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents9.default, _objectSpread(_objectSpread({}, components['Image-2']), {}, {
              className: `product${components['Image-2'].div2Fit} ${components['Image-2'] ? 'imgSize' : ''}`,
              dynamicResize: true
            }))
          })]
        }), cndHasProduct && components['Image-1'].div2Fit === 'outside' && type === _constants.BANNER_KIND.LAYOUT1_MARCA_MODELO && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "col-sm-3 outsidePictureGap",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents9.default, _objectSpread(_objectSpread({}, components['Image-1']), {}, {
            className: `product${components['Image-1'].div2Fit} `,
            dynamicResize: true
          }))
        })]
      })]
    }), components['PromoBar-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_PromoBar.default, _objectSpread({}, components['PromoBar-1']))]
  });
};
var _default = Layout1;
exports.default = _default;

//# sourceMappingURL=index.js.map